var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subitem-info"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_c('canvas',{ref:"canvas"}),_c('span',{staticClass:"size"},[_vm._v(_vm._s(_vm._f("fixedTwo")(_vm.size)))])])}
var staticRenderFns = []

export { render, staticRenderFns }